<template>
  <form id="payment-apis">
    <div class="form-group field mb-2 mt-2" :class="acctitle ? 'has-content' : ''" v-show="!failedPayment">
      <input
        name="direct-debit-holder-name"
        type="text"
        v-model="acctitle"
        id="direct-debit-holder-name"
        class="form-control input-lg acctitle"
        placeholder="Bank Account Holder Name"
        autocomplete="off"
        required
      />
    </div>

    <div class="form-group field mb-2" :class="accrouting ? 'has-content' : ''" v-show="!failedPayment">
      <input
        name="direct-debit-BSB"
        id="direct-debit-bsb"
        v-model="accrouting"
        class="form-control input-lg accrouting"
        type="number"
        placeholder="Bank Account BSB"
        required
      />
    </div>

    <div class="form-group field mb-2" :class="accno ? 'has-content' : ''" v-show="!failedPayment">
      <input
        name="direct-debit-account-number"
        v-model="accno"
        id="direct-debit-account-number"
        class="form-control input-lg accno"
        type="number"
        placeholder="Bank Account Number"
        required
      />
    </div>

    <div class="errors" v-if="serverError">
      <label>{{ serverError }}</label>
    </div>

    <div class="flex flex-col items-center" v-if="!failedPayment">
      <button
        type="button"
        :class="{ disabled: !enablePayButton() }"
        :disabled="!enablePayButton()"
        class="pay-now"
        href="#form-top"
        data-animation-duration="300"
        data-animation-easing="swing"
        id="pay-button"
        @click="payNow"
        data-smooth-scroll
        data-threshold="75"
      >
        Pay Now
      </button>
    </div>

    <div class="form-buttons" v-if="failedPayment">
      <button
        type="button"
        class="pay-now"
        href="#form-top"
        data-animation-duration="300"
        data-animation-easing="swing"
        id="retry-button"
        @click="retry"
        data-smooth-scroll
        data-threshold="75"
      >
        Retry
      </button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'BamboraDirectDebitForm',
  data() {
    return {
      accno: '',
      accrouting: '',
      acctitle: '',
      serverError: '',
      failedPayment: false,
    };
  },
  mounted() {},
  computed: mapState({
    donation: (state) => state.donation.donation,
  }),
  methods: {
    enablePayButton: function () {
      return this.acctitle &&
        this.accno &&
        this.accrouting &&
        (!this.errors || !this.errors.items || this.errors.items.length === 0)
        ? true
        : false;
    },
    payNow() {
      this.serverError = '';
      const isValid = document.querySelector('#payment-apis').reportValidity();
      if (isValid) {
        this.$emit('success', {
          accno: this.accno,
          accrouting: this.accrouting,
          acctitle: this.acctitle,
        });
      }
    },
    retry() {
      this.$emit('retry');
      this.resetForm();
    },
    resetForm() {
      (this.accno = ''), (this.accrouting = '');
      this.acctitle = '';
      this.serverError = undefined;
    },
    reset(error) {
      this.resetForm();
      if (error) {
        this.serverError = error;
        this.failedPayment = true;
      } else {
        this.failedPayment = false;
      }
    },
  },
};
</script>

<style>
#payment-apis .pay-now {
  text-transform: initial;
  font-size: 22px;
  line-height: 48px;
  height: auto;
  background-color: #3f9ffd !important;
}

#payment-apis .pay-now.disabled {
  cursor: default;
  background-color: #dedede !important;
}

.errors label {
  font-size: 15px;
  color: #ff003b;
  display: block;
}
</style>
